export const AlertImage = {
  ALERT_INFO_ICON: 'alert-info-icon'
}
